import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';

import { PageMetaService } from '@spartacus/core';

import { IVisualQuote, SdVisualQuoteComponent } from '@seb/web-design-system/visual-quote';
import { BrandsEnum, OrientationEnum, SdSpyTargetDirective } from '@seb/web-design-system/core';

import { quoteSkeleton, VisualQuoteComponentInterface, VisualQuoteModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { WrapperComponent } from '../../../components/static/core';
import { HobStateService, ImageService } from '../../../services';

@Component({
  selector: 'wc-visual-quote-module',
  templateUrl: './visual-quote-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SdVisualQuoteComponent,
    SdSpyTargetDirective
  ]
})
export class VisualQuoteModuleComponent extends AbstractModuleComponent<VisualQuoteModuleInterface> implements OnInit {
  quotes: IVisualQuote[];
  context: string;
  showMoreDesktop: boolean;
  isHob: boolean;
  activeBrand: BrandsEnum;

  constructor(
    private imageService: ImageService,
    private pageMetaService: PageMetaService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly hobStateService: HobStateService
  ) {
    super();
  }

  override mandatoryComponentFunction = (cmp: VisualQuoteComponentInterface): boolean => {
    return !!cmp.media;
  };

  override onModuleInit(module: VisualQuoteModuleInterface): void {
    if (this.useLazyLoad) {
      this.quotes = new Array(module.components.split(' ').length).fill(undefined).map(
        () => ({ ...quoteSkeleton })
      );
    }
    this.showMoreDesktop = module.layouts?.toLowerCase() === OrientationEnum.column;
    this.cdRef.markForCheck();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      combineLatest([this.module$, this.pageMetaService.getMeta()]).subscribe(([module, metaData]) => {
        this.quotes = module.componentsObjects.slice(0, 5).map((cmp) => this.toQuote(cmp));
        this.context = this.wrapper?.wrapperHeading?.headline
          ? `${metaData.title} ${this.wrapper?.wrapperHeading?.headline}`
          : metaData.title;
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.hobStateService.hobState$.subscribe(({ isHob, liveBrand, siteBrand }) => {
        this.activeBrand = liveBrand || siteBrand;
        this.isHob = isHob;
        this.cdRef.markForCheck();
      })
    );
  }

  private toQuote(component: VisualQuoteComponentInterface): IVisualQuote {
    return {
      image: this.imageService.normalizeMedia(component.media),
      quote: {
        quote: component.headline,
        author: component.subline,
        quoteImg: this.imageService.normalizeMedia(component.picto)
      }
    };
  }
}
